import React, {useState} from 'react';
import Chip from '@mui/material/Chip';
import {Popover, Row, Card, Typography, Space, Switch} from 'antd';
import {MoonOutlined, SunOutlined} from "@ant-design/icons";
import {useEnsureTickersLoaded} from "../../Hooks/useEnsureTickersLoaded";
import {useSelector, useDispatch} from "react-redux";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {stringMixin} from "../../utils/strings";
import {EventAvailableRounded} from "@mui/icons-material";
import '../../styles/BigCalendar.css';


const UPCOMING_EARNINGS_GRADIENT = 'linear-gradient(to right, #0084D9, #003D65 25%, #141416 25%)';
const UPCOMING_DIVIDEND_GRADIENT = 'linear-gradient(to right, #5300D2, #200150 25%, #141416 25%)';



const getUniqueSymbols = (calendarEvents)=>{
    let symbols = [];
    calendarEvents?.forEach?.(x=>{
        if (!symbols.includes(x.symbol)) symbols.push(x.symbol);
        if (Array.isArray(x.data)){
            x.data.forEach(y=>{
                if (!symbols.includes(y.symbol)) symbols.push(y.symbol);
            })
        }
    });
    return symbols;
}


const localizer = momentLocalizer(moment);


const mapEventsToCalendar = (events, tickers) => {
    if (!events || !tickers) return [];
    return events.map(event => {
        const tickerObject = tickers.find(x => x.symbol === event.symbol);
        return {
            start: moment(event.data[event.event_type==='upcomingdividend'?'payment_date':'report_date']).toDate(),
            end: moment(event.data[event.event_type==='upcomingdividend'?'payment_date':'report_date']).toDate(),
            title: `$${event.symbol.toUpperCase()} ${stringMixin.fmt(tickerObject?.name ?? '')}: ${event.event_type.replace('upcoming', '')}`,
            description: event.event_type === 'upcomingdividend' ?
                `Expected Dividend: $${event.data.dollar_value} on ${event.data.payment_date}. Must be owned by ${event.data.ex_date}` :
                `Earnings Estimate: $${event.data.estimate_dollar} on ${event.data.report_date}`,
            type: event.event_type
        };
    });
};

const eventPropGetter = (event) => {
    const backgroundColor = event.type === 'upcomingdividend' ? UPCOMING_DIVIDEND_GRADIENT : UPCOMING_EARNINGS_GRADIENT; // Green for dividends, Blue for earnings
    return {
        style: {
            background: backgroundColor,  fontSize: '12px', fontFamily: 'Roboto, sans-serif', paddingTop: '0px', paddingBottom: '0px',  backgroundColor: "#f0f0f0",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.2)", letterSpacing: '0.04em', textTransform: 'uppercase'
        }
    };
};




const getUniqueEvents = (calendar)=>{
    const events = [];
    const added = [];


    calendar.forEach(x=>{
        if (x.type==='etf'){
            x.data.forEach(y=>{
                if (!added.includes(y.symbol)) {
                    events.push(y);
                    added.push(y.symbol);
                }
            })
        }
    });
    console.log(events);
    return events;
}


const EventPopover = ({ events }) => (
    <div>
        {events.map(event => (
            <Typography key={event.title}>
                <strong>{event.title}</strong>
                <div>{event.description}</div>
            </Typography>
        ))}
    </div>
);


const TickerEvents = ()=>{

    const calendar = useSelector((state)=>state.user.upcomingEvents);
    const uniqueCalendarItems = getUniqueEvents(calendar||[]);
    const { tickers, loading } = useEnsureTickersLoaded(getUniqueSymbols(calendar));
    const events = mapEventsToCalendar(uniqueCalendarItems, tickers || []);
    const [theme, setTheme] = useState(localStorage.getItem('calendar_theme') || 'light');
    return (
        <>
            <Card
                bordered={false}
                className={`gapless-x gapless-y shadow-sm ${theme}`}
                style={{margin: 'auto',
                    background: theme !== 'dark' ? '#FFF' : '', borderRadius: '8px'}}
                title={
                    <Typography.Title level={5} className={'pt-1'}>
                        <EventAvailableRounded fontSize={'medium'}/> Upcoming Security Events<br/>
                        <Typography.Text style={{fontSize: '12px'}}>Includes Stocks Owned by ETFs you use</Typography.Text>
                    </Typography.Title>

            }
                extra={<Switch
                        defaultChecked={theme==='dark'}
                        checkedChildren={<MoonOutlined />}
                        unCheckedChildren={<SunOutlined />}
                        onChange={(checked)=>{
                            setTheme(checked?'dark':'light');
                            localStorage.setItem('calendar_theme', checked?'dark':'light');
                        }}
                    />}
            >
                <Calendar
                    className={theme}
                    localizer={localizer}
                    events={events}
                    eventPropGetter={eventPropGetter}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 375, width: 600 }}
                    components={{
                        month: {
                            event: ({ event }) => (
                                <Popover content={<EventPopover events={[event]} />} title="Event Details" trigger="hover">
                                    <span style={{fontSize: '8px'}}>{event.title}</span>
                                </Popover>
                            )
                        },
                        day: {
                            event: ({ event }) => (
                                <Typography>
                                    <strong style={{color: "#FFF", fontWeight: '300', fontSize: '16px'}}>{event.title}</strong>
                                    <div style={{color: "#ccc", fontWeight: '300', fontSize: '14px'}}>{event.description}</div>
                                </Typography>
                            )
                        }
                    }}
                />
            </Card>
        </>
    )

}

export default TickerEvents;



